import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie';

Vue.use(VueRouter)

const pages=require.context('../views', true,/.vue$/);
const pageRoutes=[]
for(let i=0;i<pages.keys().length;i++){
    let path=pages.keys()[i].replace(/^.\//,"")
    pageRoutes.push({
        path: '/'+(pages(pages.keys()[i]).default.name || pages(pages.keys()[i]).default.path),
        name: pages(pages.keys()[i]).default.name,
        component: () => import(`@/views/${path}`),
        meta: pages(pages.keys()[i]).default.meta
    })
}
const routes = [
  {
    path: '',
    redirect: '/home',
    name: 'home',
    component: () => import('@/components/common/layout.vue'),
    children: [
      ...pageRoutes
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/components/common/login.vue')
  },
  {
    path: '/ssologin',
    name: 'ssologin',
    component: () => import('@/components/common/ssologin.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/components/common/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (Cookies.get('token')) {  //如果用户已经登录
    if (to.path == "/login") {  //如果用户已经登录且跳转前往登录页面
      next({ name: "home" })
    } else if (to.path == "/ssologin"){  //如果用户跳转的是其他页面则判断其是否拥有权限
      next()
    } else {  //如果用户跳转的是其他页面则判断其是否拥有权限
      next()
    }
  } else {
    if (to.path == "/login") {
      next()
    } else if (to.path == "/ssologin"){  //如果用户跳转的是其他页面则判断其是否拥有权限
      next()
    } else {  //如果用户跳转的是其他页面则判断其是否拥有权限
      next({ name: "login" })
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js